import React, { createContext, useState, useContext } from 'react';

const FilterContext = createContext();

export const useFilters = () => useContext(FilterContext);

export const FilterProvider = ({ children }) => {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [selectedFlavor, setSelectedFlavor] = useState('all');
  const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [selectedProductIds, setSelectedProductIds] = useState([]);

  const openFilterModal = () => setIsFilterModalOpen(true);
  const closeFilterModal = () => setIsFilterModalOpen(false);

  const applyFilters = (filters) => {
    setSelectedFlavor(filters.flavor);
    setDateRange(filters.dateRange);
    closeFilterModal();
  };

  const clearFilters = () => {
    setSelectedFlavor('all');
    setDateRange({ start: '', end: '' });
  };

  const handleProductFilterChange = (productIds) => {
    setSelectedProductIds(productIds);
  };

  const clearProductFilters = () => {
    setSelectedProductIds([]);
  };

  const value = {
    isFilterModalOpen,
    openFilterModal,
    closeFilterModal,
    selectedFlavor,
    dateRange,
    applyFilters,
    clearFilters,
    setSelectedFlavor,
    setDateRange,
    selectedProductIds,
    handleProductFilterChange,
    clearProductFilters
  };

  return (
    <FilterContext.Provider value={value}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilter must be used within a FilterProvider');
  }
  return context;
};
